import { globalStores } from '@/editor/stores';
import FurnitureEntity from '@/editor/entities/furnitureEntity';
import { EEntityType } from '@/editor/types';
import { FurnitureInstanceManager } from '@/editor/utils/furniture/furnitureInstanceManager';
import { ENTITY_RENDER_ORDER } from '@/editor/constant/entity';

export class FurnitureManager {
  private _list: FurnitureEntity[] = [];

  // InstancedMesh 管理器
  private _instanceManager = new FurnitureInstanceManager(ENTITY_RENDER_ORDER.furniture);

  constructor() {}

  get entities() {
    return this._list;
  }

  /**
   * 获取 InstancedMesh 管理器
   */
  get instanceManager() {
    return this._instanceManager;
  }

  private getDataList() {
    const furnitureHiddenIds = globalStores.visibilityStore.getHiddenEntitiesIdsByEntityType(EEntityType.Furniture);
    return globalStores.modelStore.getFurnitureDatas().filter((data) => !furnitureHiddenIds.has(data.id));
  }

  // ========== Entity 管理方法 ==========

  update() {
    const furnitureDatas = this.getDataList();
    const newFurnitureDataMap = new Map(furnitureDatas.map((data) => [data.id, data]));

    for (let i = this._list.length - 1; i >= 0; i--) {
      const entity = this._list[i];
      const newFurnitureData = newFurnitureDataMap.get(entity.id);
      if (!newFurnitureData) {
        this.deleteEntity(i);
      } else {
        entity.update(newFurnitureData);
      }

      newFurnitureDataMap.delete(entity.id);
    }

    for (const data of newFurnitureDataMap.values()) {
      const entity = new FurnitureEntity({ id: data.id, visible: true });
      this.addEntity(entity);
      entity.update(data);
    }
  }

  // 强制更新所有家具，在场景模式切换时调用
  forceUpdate() {
    this._list.forEach((entity) => entity.update({ forceUpdate: true }));
  }

  private deleteEntity(index: number) {
    if (index >= this._list.length || index < 0) return;
    this._list[index].dispose();
    this._list.splice(index, 1);
  }

  addEntity(entity: FurnitureEntity) {
    this._list.push(entity);
  }

  getEntity(entityId: string) {
    return this._list.find((entity) => entity.id === entityId);
  }

  updateEntity({ id }: { id: string }) {
    const data = globalStores.modelStore.getFurnitureData(id);
    let entity = this.getEntity(id);
    if (!data) {
      if (entity) this.deleteEntity(this._list.indexOf(entity));
      return;
    }

    if (!entity) {
      entity = new FurnitureEntity({ id: data.id, visible: true });
      this.addEntity(entity);
    }

    entity.update(data);
  }

  showWorkPoints(ids: string[]) {
    this._list.forEach((entity) => {
      if (ids.includes(entity.id)) {
        entity.setWorkPointVisible(true);
      } else {
        entity.setWorkPointVisible(false);
      }
    });
  }

  /**
   * 清理所有家具实体和 InstancedMesh 资源
   */
  dispose() {
    this._list.forEach((entity) => entity.dispose());
    this._list = [];
    this._instanceManager.dispose();
  }
}
